import { render, staticRenderFns } from "./CryptoCurrencyCard.vue?vue&type=template&id=f9e05916"
import script from "./CryptoCurrencyCard.vue?vue&type=script&lang=js"
export * from "./CryptoCurrencyCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports